import { ZodSchema } from "@validation/utils/schemaUtils";
import { GasoilPriceSource } from "__generated__/enums";
import z from "zod";

export const gasoilPriceSchema = z.object({
	id: z.number().nullable(),
	date: ZodSchema.requiredField(z.string().nullable()),
	price: ZodSchema.requiredField(z.number().nullable()),
	priceDifference: z.number().nullable(),
	percentageDifference: z.number().nullable(),
	source: z.enum(GasoilPriceSource),
	pricedQuantity: z.number().nullable(),
});

export type GasoilPriceSchemaInput = z.input<typeof gasoilPriceSchema>;
export type GasoilPriceSchemaOutput = z.output<typeof gasoilPriceSchema>;
